import React, { useEffect, useState } from "react";
import WelcomeComp from "../../pages/Dashboard/WelcomeComp";
import { Row, Col, Card, CardBody, Media } from "reactstrap";
import { Link } from "react-router-dom";
import { postSubmitForm } from "../../helpers/forms_helper";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";

const DashboardForOwner = (props) => {
  const [itemData, setItemData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [poData, setPoData] = useState([]);

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      loadOwnerData();
    }
  }, [dateFrom, dateTo]);

  const loadOwnerData = async () => {
    let url = process.env.REACT_APP_BASEURL + "reports/owner_dashboard";
    let response = await postSubmitForm(url, {
      date_from: dateFrom,
      date_to: dateTo,
    });
    if (response.status === 1) {
      setItemData(response.data.itemeorder_count);
      setProductData(response.data.productorder_count);
      setPoData(response.data.purchaseorder_count);
    }
  };
  return (
    <>
      <Row>
        <Col md="6">
          <WelcomeComp />
        </Col>
        <Row>
          <Col md="12">
            <Card className="mini-stats-wid">
              <CardBody>
                <AvForm>
                  <Row>
                    <Col lg={6}>
                      <AvField
                        name="dateFrom"
                        label={props.t("From Date")}
                        placeholder={props.t("Select")}
                        type="date"
                        value={dateFrom}
                        onChange={(e, v) => {
                          setDateFrom(formatDate(e.target.value));
                        }}
                        errorMessage={props.t("Date cannot be empty.")}
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </Col>
                    <Col lg={6}>
                      <AvField
                        name="dateTo"
                        label={props.t("To Date")}
                        placeholder={props.t("Select")}
                        type="date"
                        value={dateTo}
                        onChange={(e, v) => {
                          setDateTo(formatDate(e.target.value));
                        }}
                        errorMessage={props.t("Date cannot be empty.")}
                        validate={{
                          required: { value: true },
                        }}
                      />
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Link to="#">
              <Card
                className="mini-stats-wid"
                style={{
                  backgroundColor: "#ffebee",
                  color: "#b71c1c",
                  border: "1px solid #f7766f",
                }}
              >
                <CardBody
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                    height: "100px",
                  }}
                >
                  <Media>
                    <Media body>
                      <p className="fw-medium">Total Central Store Order</p>
                      <h4 className="mb-0" style={{ color: "#b71c1c" }}>
                        {itemData}
                      </h4>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md="4">
            <Link to="#">
              <Card
                className="mini-stats-wid"
                style={{
                  backgroundColor: "#e3f2fd",
                  color: "#0d47a1",
                  border: "1px solid #9eb3e8",
                }}
              >
                <CardBody
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                    height: "100px",
                  }}
                >
                  <Media>
                    <Media body>
                      <p className="fw-medium">Total Central Kitchen Order</p>
                      <h4 className="mb-0" style={{ color: "#0d47a1" }}>
                        {productData}
                      </h4>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md="4">
            <Link to="#">
              <Card
                className="mini-stats-wid"
                style={{
                  backgroundColor: "#e8f5e9",
                  color: "#1b5e20",
                  border: "1px solid #9dde81",
                }}
              >
                <CardBody
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                    height: "100px",
                  }}
                >
                  <Media>
                    <Media body>
                      <p className="fw-medium">Total Purchase Order</p>
                      <h4 className="mb-0" style={{ color: "#1b5e20" }}>
                        {poData}
                      </h4>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Link>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default withNamespaces()(DashboardForOwner);
